import { useDateFormat } from "@vueuse/core";

export const useDate = () => {
  const formatForBack = "YYYY-MM-DD";

  const formatDate = (date, format = "DD.MM.YYYY") => {
    if (!date) return;
    // Используем useDateFormat для конвертации в локальное время без смещения часовых поясов
    return useDateFormat(date, format).value;
  };

  return {
    formatDate,
    formatForBack,
  };
};
